import {
  Button,
  Dialog,
  DialogClose,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@sib/ui';
import { useAppTranslation } from '@spendbrain/modules/vendors/hooks';
import { ContractPreview } from './ContractPreview';
import type { ContractPreview as ContractPreviewType } from './ContractsTable.utils';

interface ContractPreviewDialogProps {
  contractPreview: ContractPreviewType | null;
  onClose: () => void;
}

export const ContractPreviewDialog = ({
  contractPreview,
  onClose,
}: ContractPreviewDialogProps) => {
  const { t } = useAppTranslation();

  return (
    <Dialog
      open={!!contractPreview}
      onOpenChange={isOpen => !isOpen && onClose()}
    >
      <DialogContent className="flex h-[90vh] max-w-[95vw] flex-col overflow-y-auto px-3 py-5 sm:max-w-[90vw] sm:px-12.5">
        <DialogHeader>
          <DialogTitle className="text-primary text-xl font-semibold">
            {contractPreview?.title || t('pages.vendors.tabs.vendorContracts')}
          </DialogTitle>
        </DialogHeader>
        {contractPreview && (
          <div className="flex flex-col gap-4">
            <ContractPreview
              fileUrl={contractPreview.fileUrl}
              title={contractPreview.title || ''}
            />
            <div className="flex justify-center">
              <DialogClose asChild>
                <Button type="button" variant="outline" onClick={onClose}>
                  {t('back')}
                </Button>
              </DialogClose>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
